import { gql } from '@apollo/client';
import { useQueryCoordinate, useMutationCoordinate } from '../graphql.hooks';

export const LIST_WORKFLOWS = gql`
  query ListWorkflows {
    listWorkflows {
      id
      name
      activeExecutions
    }
  }
`;

export const GET_WORKFLOW_EXECUTION = gql`
  query GetWorkflowExecution($executionId: String!) {
    workflowExecution(input: { executionId: $executionId }) {
      executionId
      startedAt
      endAt
      steps {
        executionId
        prevExecutionId
        originalStepId
        attempt
        workflowId
        stepName
        scheduledFor
        startedAt
        endAt
        triggeredAt
        inputPayload
        outputResults
        spanType
        outgoingJobs
        outgoingSentAt
        executionStatus {
          isRunning
          lastHeartbeatAt
        }
      }
    }
  }
`;

export const WORKFLOW_LOG_FILE = gql`
  query GetWorkflowLogFile($input: WorkflowLogFileInput!) {
    workflowLogFile(input: $input) {
      content
      filename
    }
  }
`;

export const TRIGGER_SCHEDULED_STEP_EARLY = gql`
  mutation TriggerScheduledStepEarly($input: TriggerScheduledStepEarlyInput!) {
    triggerScheduledStepEarly(input: $input) {
      success
      error
    }
  }
`;

export const START_WORKFLOW = gql`
  mutation StartWorkflow($input: WorkflowStartInput!) {
    startWorkflow(input: $input) {
      workflowId
      success
    }
  }
`;

export const WORKFLOW_STEP_RECOVER = gql`
  mutation WorkflowStepRecover($input: WorkflowStepRecoverInput!) {
    workflowStepRecover(input: $input) {
      success
    }
  }
`;

// Custom hooks using coordinate
export const useListWorkflows = (options = {}) => {
  return useQueryCoordinate(LIST_WORKFLOWS, options);
};

export const useGetWorkflowExecution = (options = {}) => {
  return useQueryCoordinate(GET_WORKFLOW_EXECUTION, options);
};

export const useGetWorkflowLogFile = (options = {}) => {
  return useQueryCoordinate(WORKFLOW_LOG_FILE, options);
};

export const useStartWorkflow = (options = {}) => {
  return useMutationCoordinate(START_WORKFLOW, options);
};

export const useWorkflowStepRecover = (options = {}) => {
  return useMutationCoordinate(WORKFLOW_STEP_RECOVER, options);
};

export const useTriggerScheduledStepEarly = (options = {}) => {
  return useMutationCoordinate(TRIGGER_SCHEDULED_STEP_EARLY, options);
}